import React, { useEffect, useRef, useState } from 'react';
import { showBannersInFeeds } from './utils/banners';
import { FEED_BANNER_CREATIVE } from './constants/banners';
import useBannerScaleToFit from './hooks/useBannerScaleToFit';
import useCollapseOnGhostBanner from './hooks/useCollapseOnGhostBanner';

import Classes from './Banners.scss';

type TBannerHomeTopContainerProps = {
  isFeedItem?: boolean;
};

// this component is used by for you feed and top container
// logic is based on viewport size
const BannerHomeTopContainer = ({ isFeedItem }: TBannerHomeTopContainerProps) => {
  const [showBanner, setShowBanner] = useState(true);
  const [bannerBreakOutClass, setBannerBreakOutClass] = useState('');
  const containerRef = useRef<HTMLDivElement | null>(null);
  const slotRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    window.addEventListener('banner-breakout', function () {
      setBannerBreakOutClass(Classes.bannerBreakout);
    });
  }, []);

  useEffect(() => {
    if (!isFeedItem) {
      setShowBanner(!showBannersInFeeds());
    }
  }, [showBanner, isFeedItem]);

  // Collapse when ghost iframe (height ≤ 1px) detected
  useCollapseOnGhostBanner(true, slotRef, containerRef);

  // Scale to fit container (only for feed variant)
  useBannerScaleToFit({
    isEnabled: Boolean(isFeedItem),
    containerRef: containerRef as unknown as React.RefObject<HTMLElement>,
    baseWidth: FEED_BANNER_CREATIVE.width,
    baseHeight: FEED_BANNER_CREATIVE.height,
  });

  return (
    <>
      {showBanner && (
        <div
          id="banner-top-dt-container"
          className={`hz-FeedBannerBlock ${bannerBreakOutClass} ${
            isFeedItem ? `${Classes.bannerFeedItem}` : Classes.bannerTopContainer
          }`}
          ref={containerRef}
        >
          <div id="banner-top-dt" ref={slotRef} className={isFeedItem ? Classes.bannerScale : undefined}></div>
        </div>
      )}
    </>
  );
};

export default BannerHomeTopContainer;
